module.exports = __webpack_public_path__ + "media/goforajourney/img/barcelona/img510-02d8892ad6976a665d9be4ed47f703c6.jpg";